import { render, staticRenderFns } from "./Odontograma.vue?vue&type=template&id=38fef7ee&scoped=true"
import script from "./Odontograma.vue?vue&type=script&lang=js"
export * from "./Odontograma.vue?vue&type=script&lang=js"
import style0 from "./Odontograma.vue?vue&type=style&index=0&id=38fef7ee&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fef7ee",
  null
  
)

export default component.exports